import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WallFolderWithWeatherRelations, UpdateWallFolderDto } from 'types';

export const updateWeatherFolder = ({
  data,
  folderId,
}: {
  data: UpdateWallFolderDto;
  folderId: number;
}): Promise<WallFolderWithWeatherRelations> => {
  return axios.put(`/api/folders/weather/${folderId}`, data);
};

type UseUpdateWeatherFolderOptions = {
  config?: MutationConfig<typeof updateWeatherFolder>;
};

export const useUpdateWeatherFolder = ({
  config,
}: UseUpdateWeatherFolderOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherFolders) {
        queryClient.setQueryData(
          ['weatherFolders'],
          context.previousWeatherFolders
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherFolders']);
    },
    ...config,
    mutationFn: updateWeatherFolder,
  });
};
